/* eslint-disable global-require */
module.exports = {
	en: require("./en"),
	de: require("./de"),
};
